import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { waLink } from "@/lib/whatsapp";

export default function MobileStickyCTA() {
  const { settings } = useSettings();
  const wa = settings?.whatsapp || {};
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white/90 backdrop-blur-xl border-t border-slate-200 px-4 py-3 flex gap-3" data-testid="mobile-sticky-cta">
      <Link to="/consultation" className="flex-1">
        <button className="w-full h-11 rounded-full bg-primary text-white font-medium text-sm">Free Consultation</button>
      </Link>
      <a href={waLink(wa.number, wa.default_message)} target="_blank" rel="noreferrer" className="shrink-0">
        <button className="h-11 w-11 grid place-items-center rounded-full bg-green-500 text-white"><MessageCircle className="w-5 h-5" /></button>
      </a>
    </div>
  );
}
